export function getBackendBaseUrl(): string {
  const backendUrl = process.env.REACT_APP_BACKEND_URL?.replace(/\/+$/, '');
  const apiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '');

  if (backendUrl) {
    return backendUrl;
  }
  if (apiUrl) {
    return apiUrl.replace(/\/api\/v1$/, '');
  }
  return 'http://localhost:8013';
}
